module.exports = __webpack_public_path__ + "img/map-papa.11b8d1c2.png";